// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Toast Container styles
 * Manages positioning and stacking of toasts
 */

.toast-portal {
  position: fixed;
  z-index: 10000;
  pointer-events: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.toast-container {
  position: fixed;
  display: flex;
  flex-direction: column;
  pointer-events: all;
  z-index: 10000;
}

/* Position variants */
.toast-container-top-left {
  top: 20px;
  left: 20px;
}

.toast-container-top-right {
  top: 20px;
  right: 20px;
}

.toast-container-bottom-left {
  bottom: 20px;
  left: 20px;
  flex-direction: column-reverse;
}

.toast-container-bottom-right {
  bottom: 20px;
  right: 20px;
  flex-direction: column-reverse;
}

/* Responsive */
@media (max-width: 480px) {
  .toast-container-top-left,
  .toast-container-top-right {
    left: 0;
    right: 0;
    align-items: center;
  }

  .toast-container-bottom-left,
  .toast-container-bottom-right {
    left: 0;
    right: 0;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Common/ToastContainer.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE;;IAEE,OAAO;IACP,QAAQ;IACR,mBAAmB;EACrB;;EAEA;;IAEE,OAAO;IACP,QAAQ;IACR,mBAAmB;EACrB;AACF","sourcesContent":["/**\n * Toast Container styles\n * Manages positioning and stacking of toasts\n */\n\n.toast-portal {\n  position: fixed;\n  z-index: 10000;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.toast-container {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  pointer-events: all;\n  z-index: 10000;\n}\n\n/* Position variants */\n.toast-container-top-left {\n  top: 20px;\n  left: 20px;\n}\n\n.toast-container-top-right {\n  top: 20px;\n  right: 20px;\n}\n\n.toast-container-bottom-left {\n  bottom: 20px;\n  left: 20px;\n  flex-direction: column-reverse;\n}\n\n.toast-container-bottom-right {\n  bottom: 20px;\n  right: 20px;\n  flex-direction: column-reverse;\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .toast-container-top-left,\n  .toast-container-top-right {\n    left: 0;\n    right: 0;\n    align-items: center;\n  }\n\n  .toast-container-bottom-left,\n  .toast-container-bottom-right {\n    left: 0;\n    right: 0;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
